<template>
    <div>
        <b-card class="mb-0 smallinputs" header-tag="header" footer-tag="footer" border-variant="primary">
            <!-- {{ JSON.parse(value.metadata).banking[0].label }} -->
            <!-- {{ value }} -->
            <b-row>
                <b-col cols="6">
                    <b-card-body class="py-0 px-0 h6 h-100pct mb-0">

                        <b-row class="h-100pct py-2 ml-0 " no-gutters>
                            <b-col cols="6" class="border-right background-corn-light pl-2">
                                <b-row>
                                    <b-col>
                                        <span class="text-primary small"
                                            v-html="$moment.unix(value.date_at * .001).utc(true).format('DD MMM YYYY')"></span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <span class="strong"
                                            v-html="value.description.length > 40 ? value.description.slice(0, 37) + '...' : value.description"></span>
                                        <br />
                                        <span class="strong">{{ value.reference }}</span>
                                        <div :id="'statement-container' + value.id" class="w-350px">
                                            <b-link :id="'statement-reactive-' + value.id" class="small">More
                                                details...</b-link>
                                            <b-popover :target="'statement-reactive-' + value.id" triggers="click"
                                                :show.sync="popoverStatement" placement="auto"
                                                :container="'statement-container' + value.id" ref="popover"
                                                @show="onShow" @shown="onShown" @hidden="onHidden">
                                                <template #title>
                                                    <b-button size="sm" @click="onClose" class="close"
                                                        aria-label="Close">
                                                        <span class="d-inline-block" aria-hidden="true">&times;</span>
                                                    </b-button>
                                                    Statement Details
                                                </template>
                                                <b-list-group>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Transaction Date:</span>
                                                        <span
                                                            v-html="$moment.unix(value.date_at * .001).utc(true).format('DD MMM YYYY')"></span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Payee:</span>
                                                        <span>{{ value.payee }}</span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Reference:</span>
                                                        <span>{{ value.reference }}</span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Description:</span>
                                                        <span>{{ value.description }}</span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Transaction Amount:</span>
                                                        <span>{{ value.amount }}</span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">Transaction Type:</span>
                                                        <span>{{ value.type.charAt(0).toUpperCase() }}{{
                                                            value.type.substr(1).toLowerCase() }}</span>
                                                    </b-list-group-item>
                                                    <b-list-group-item>
                                                        <span class="mr-2">ID:</span>
                                                        <span>{{ value.id }}</span>
                                                    </b-list-group-item>
                                                </b-list-group>

                                            </b-popover>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row align-v="end" class="mt-3 py-0 mx-0" no-gutters>
                                    <b-col class="text-right small">
                                        <b-nav-item-dropdown size="sm" text="Options" right class="list-none">
                                            <b-dropdown-item :to="'/bankingsrules?id=' + value.id + '&'">
                                                Create statement rule
                                            </b-dropdown-item>

                                            <b-dropdown-item variant="danger" href="#">Delete statement
                                                line</b-dropdown-item>
                                        </b-nav-item-dropdown>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col class="border-right background-corn-light pr-2">
                                <b-row align-v="end" class="h-100pct">
                                    <b-col align-self="start" class="text-right" v-show="value.spent">
                                        <span class="text-right text-danger small">Spent</span><br />
                                        <span class="strong">{{ Math.abs(value.spent).toFixed(2) }}</span>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col class="border-right background-corn-light pr-2">
                                <b-row align-v="end" class="h-100pct">
                                    <b-col align-self="start" class="text-right" v-show="value.received">
                                        <span class="text-right text-primary small">Received</span><br />
                                        <span class="strong">{{ value.received }}</span>
                                    </b-col>
                                </b-row>
                            </b-col>

                        </b-row>


                    </b-card-body>
                </b-col>
                <b-col cols="auto" class="text-center px-0 w-50px" align-self="center">
                    <b-spinner v-if="!item.id" variant="primary" type="grow"></b-spinner>
                    <!-- {{matchexact}} -->
                    <b-button v-if="matchexact && !value.reconciled" size="sm" squared variant="danger"
                        @click="remove_it">
                        Remove and Redo
                    </b-button>
                </b-col>

                <b-col>
                    <b-card-body class="py-0 px-0">

                        <div class="relative">
                            <div class="strong absolute ar-0 at-6px">
                                <b-link v-if="!value.reconciled" @click="matchesShow = !matchesShow">Find &
                                    Post</b-link>
                                <i @click="matchesShow = !matchesShow" class="text-primary strong ml-1"
                                    :class="matchesShow ? 'fa fa-long-arrow-up' : 'fa fa-long-arrow-down'"></i>
                            </div>
                        </div>
                        <b-tabs small class="gridtabs mintabs reconcile" v-model="tabindex">
                            <b-tab small @click="matchesShow = true">

                                <template #title>
                                    <span>Select</span>
                                </template>

                                <div v-if="match" class="relative pb-1">

                                    <b-row class="mt-1 background-primary-green-light border px-0" no-gutters>
                                        <b-col class="p-2 border-left-primary-strong" cols="auto">
                                            <i v-if="match.type == 'reconciled'"
                                                class="fa fa-exchange fa-2x text-orange" aria-hidden="true"
                                                title="Reconciled"></i>
                                            <i v-if="match.type == 'matched'"
                                                class="fa fa-check-square-o fa-2x text-primary" aria-hidden="true"
                                                title="Matched"></i>
                                            <i v-if="match.type == 'suggestion'" class="fa fa-bolt fa-2x text-primary"
                                                aria-hidden="true" title="Suggestion"></i>
                                        </b-col>
                                        <b-col class="py-1 px-2 w-180px">
                                            <span class="text-primary"
                                                v-html="$moment.unix(match.date_at * .001).utc(true).format('DD MMM YYYY')"></span>
                                            <br />
                                            <span class="strong" v-html="match.who"></span> <span class="strong"
                                                v-html="match.why"></span>
                                            <br />
                                            <span class="strong" v-html="match.ref"></span>
                                            <br />

                                            <div :id="'match-container' + value.id" class="w-250px">
                                                <b-link :id="'match-reactive-' + value.id">More
                                                    details...</b-link>
                                                <b-popover :target="'match-reactive-' + value.id" triggers="click"
                                                    :show.sync="popoverMatch" placement="auto"
                                                    :container="'match-container' + value.id" ref="popover"
                                                    @show="onShow" @shown="onShown" @hidden="onHidden">
                                                    <template #title>
                                                        <b-button size="sm" @click="onClose" class="close"
                                                            aria-label="Close">
                                                            <span class="d-inline-block"
                                                                aria-hidden="true">&times;</span>
                                                        </b-button>
                                                        Match Details
                                                    </template>
                                                    <b-list-group>
                                                        <b-list-group-item>
                                                            <span class="mr-2">Match Date:</span>
                                                            <span
                                                                v-html="$moment.unix(match.date_at * .001).utc(true).format('DD MMM YYYY')"></span>
                                                        </b-list-group-item>
                                                        <b-list-group-item>
                                                            <span class="mr-2">Who:</span>
                                                            <span>{{ match.who }}</span>
                                                        </b-list-group-item>
                                                        <b-list-group-item>
                                                            <span class="mr-2">What:</span>
                                                            <span>{{ match.what }}</span>
                                                        </b-list-group-item>
                                                        <b-list-group-item>
                                                            <span class="mr-2">Why:</span>
                                                            <span>{{ match.why }}</span>
                                                        </b-list-group-item>
                                                        <b-list-group-item>
                                                            <span class="mr-2">Match Amount:</span>
                                                            <span>{{ match.amount }}</span>
                                                        </b-list-group-item>
                                                        <!-- <b-list-group-item>
                                                        <span class="mr-2">ID:</span>
                                                        <span>{{ value.id }}</span>
                                                    </b-list-group-item> -->
                                                    </b-list-group>
                                                </b-popover>
                                            </div>

                                        </b-col>

                                        <b-col cols="3" class="pt-1 px-2 border-left border-right text-right">
                                            <span class="text-danger" v-show="value.spent">{{ matched_label
                                                }}</span><br />
                                            <h6 class="strong" v-show="value.spent">
                                                {{
                                                    Math.abs(match.amount).toFixed(2)
                                                }}</h6>

                                        </b-col>
                                        <b-col cols="3" class="pt-1 px-2 text-right">
                                            <span class="text-primary" v-show="value.received">{{ matched_label
                                                }}</span><br />
                                            <h6 class="strong" v-show="value.received">
                                                {{
                                                    Math.abs(match.amount).toFixed(2)
                                                }}</h6>
                                        </b-col>
                                    </b-row>


                                </div>
                                <div v-if="!match" class="relative">
                                    <b-row class="mt-1 border px-0" no-gutters>
                                        <b-col class="text-gray text-center p-4 text-12px background-light">
                                            Find & select matching entries below
                                        </b-col>
                                    </b-row>

                                </div>

                            </b-tab>
                            <b-tab small v-if="!value.reconciled">

                                <template #title>
                                    <span>Create</span>
                                </template>
                                <p class="mt-2">
                                    <b-row class="my-0" no-gutters>
                                        <b-col cols="12" sm="6">
                                            <b-form-group label="Who" label-for="Who" label-cols="auto">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.who"
                                                        placeholder="Name of the contact..." size="sm"
                                                        class="text-primary"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.who = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="pl-1">
                                            <b-form-group label="What" label-for="what" label-cols="auto">
                                                <treeselect class="sm" instanceId="nlcode" type="number"
                                                    v-model="item.nlcode" :clearable="true" :options="nlcode_options"
                                                    placeholder="Choose the account...">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Why" label-for="why" label-cols="auto">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.why"
                                                        placeholder="Enter a description..." size="sm"
                                                        class="text-primary"></b-form-input>
                                                    <!-- <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="item.why = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append> -->
                                                </b-input-group>
                                            </b-form-group>

                                            <!-- <b-form-group label="Why" label-for="why" label-cols="12">
                                                <b-form-textarea id="details" v-model="item.why" placeholder="Why" rows="2"
                                                    class="smalltextarea"></b-form-textarea>
                                            </b-form-group> -->

                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="VAT" label-for="vat" label-cols="auto">
                                                <treeselect class="sm" instanceId="vat" type="number" v-model="item.vat"
                                                    :clearable="false" :options="vat_options"></treeselect>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>
                            <b-tab small v-if="!value.reconciled">

                                <template #title>
                                    <span>Transfer</span>
                                </template>

                                <p class="mt-4">
                                    <b-row class="my-0" no-gutters>
                                        <b-col cols="12" sm="6" class="pl-1">
                                            <b-form-group label="Acc" label-for="banking" label-cols="auto">
                                                <treeselect class="sm" instanceId="banking" type="number"
                                                    v-model="item.acc" :clearable="true" :options="banking_options"
                                                    placeholder="Choose the account...">
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" class="pl-1">
                                            <b-form-group label="Ref" label-for="Ref" label-cols="auto">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.ref"
                                                        placeholder="Reference..." size="sm"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.ref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>
                                </p>



                            </b-tab>
                            <b-tab small v-if="!value.reconciled">

                                <template #title>
                                    <span>Discuss</span>

                                </template>
                                <p class="py-1">
                                    <b-row no-gutters>
                                        <b-col>
                                            <b-form-textarea v-model="item.notes" placeholder="Discuss" rows="3"
                                                class="xstextarea pl-1 pt-0"></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                    <b-row align-h="end">
                                        <!-- <b-col class="small text-right">Ctrl + S at any time to save

                                        </b-col> -->
                                        <b-col cols="auto">
                                            <b-button class="xs strong" variant="link"
                                                @click="bankingsline_save([item])">Save
                                                It</b-button>
                                        </b-col></b-row>
                                </p>
                            </b-tab>
                        </b-tabs>

                    </b-card-body>
                </b-col>
            </b-row>

        </b-card>

        <b-card class="px-2 font-normal" v-show="matchesShow">

            <!-- JSON.parse(value.metadata).banking[0].label.includes('BSP') -->
            <!-- {{ value.metadata }} -->
            <div v-if="1 == 0">
                Just for tickets
            </div>

            <div v-else>
                <b-row class="border-bottom pt-2 pb-3">
                    <b-col>

                        <b-row>
                            <b-col class="strong text-2x">1. {{ paymentdirection }}
                            </b-col>
                        </b-row>

                        <b-row class="pt-2 pb-1">
                            <b-col class="strong text-1x pt-2">2. The sum of your selected entries must
                                match the
                                money {{
                                    spentorreceived
                                }}.
                                Make
                                adjustments,
                                as needed.</b-col>
                            <!-- <b-col v-if="1 == 0" cols="auto" class="text-right pr-0">
                                <b-nav-item-dropdown size="sm" text="Adjustments" right class="list-none">
                                    <b-dropdown-item href="#">X</b-dropdown-item>
                                    <b-dropdown-item href="#">Y</b-dropdown-item>
                                </b-nav-item-dropdown>
                            </b-col> -->
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-row class="text-primary border-top ml-0 pb-3">
                                    <b-col class="pt-1 pl-3 strong h6">Must match money GBP {{
                                        Math.abs(item.amount).toFixed(2)
                                        }}
                                    </b-col>
                                    <b-col v-if="difference" class="pt-1 strong h6 text-right pr-4"
                                        :class="parseFloat(difference) == 0 ? 'text-primary' : 'text-danger'">Total is
                                        out by
                                        GBP
                                        {{
                                            parseFloat(difference).toFixed(2) }}</b-col>
                                </b-row>
                            </b-col>

                            <!-- <b-col v-if="match" cols="auto" class="pt-1 text-right strong text-danger"><i
                        class="fa fa-exclamation-circle"></i>Total
                    is out by: {{ match.difference }}</b-col> -->
                        </b-row>
                        <b-overlay opacity="0.3" :show="allocateonly == true">
                            <template #overlay>
                                <b-icon icon=""></b-icon>
                            </template>

                            <b-row class="mt-2">
                                <b-col>
                                    <b-tabs small class="gridtabs" v-model="payindex">
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-2 mr-1">
                                                    <i class="fa fa-wpforms mr-1"></i>
                                                    Sales
                                                </div>
                                            </template>
                                            <b-row class="mt-2 px-0">
                                                <!-- {{ sl_lines }} -->
                                                <b-col>
                                                    <div
                                                        class="mt-0 mb-1 text-center nested availtable datatable smallinputs etable">
                                                        <table
                                                            class="w-100pct table b-table table-striped table-hover table-sm mb-1"
                                                            style="table-layout:fixed">
                                                            <!-- <tr class="header-dark"> -->
                                                            <tr class="header-primary text-white">

                                                                <td colspan="2" class="text-center w-30px">Lines </td>

                                                                <td class="text-center w-35px"
                                                                    v-if="sl_columns.includes('prefix')">
                                                                    Type
                                                                </td>

                                                                <td class="text-right w-100px"
                                                                    v-if="sl_columns.includes('description')">
                                                                    Description
                                                                </td>

                                                                <td class="text-center w-80px"
                                                                    v-if="sl_columns.includes('slac')">
                                                                    SL A/C
                                                                </td>

                                                                <td class="text-center w-80px"
                                                                    v-if="sl_columns.includes('eventcode')">
                                                                    Event
                                                                </td>

                                                                <td class="text-center w-110px"
                                                                    v-if="sl_columns.includes('nlcode')">
                                                                    NL Code
                                                                </td>

                                                                <td class="text-center w-50px"
                                                                    v-if="sl_columns.includes('amount')">
                                                                    <span
                                                                        v-html="value.amount > 0 ? 'Received' : 'Spent'"></span>
                                                                </td>

                                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                                    class="table-b-table-default text-center w-25px">
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td colspan="5"></td>
                                                            </tr>
                                                            <tbody role="rowgroup">
                                                                <tr v-for="(line, index) in sl_lines" :key="index">

                                                                    <td class="">
                                                                        <span class="small text-primary">{{ index + 1
                                                                            }}.</span>
                                                                    </td>
                                                                    <td class="">
                                                                        <!-- <i :class="line.icon" class="mr-2"></i> -->
                                                                        <i class="fa fa-handshake-o"></i>
                                                                    </td>

                                                                    <td v-if="sl_columns.includes('prefix')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect instanceId="type"
                                                                                    v-model="line.prefix"
                                                                                    :clearable="true"
                                                                                    :options="prefix_options"
                                                                                    :multiple="false" class="h-20px"
                                                                                    @select="edited = true">
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="sl_columns.includes('description')">
                                                                        <b-form-group class="mb-3px">
                                                                            <b-input-group>
                                                                                <b-form-input size="sm"
                                                                                    v-model="line.description"
                                                                                    placeholder="Description"
                                                                                    class="text-left"></b-form-input>
                                                                                <b-input-group-append>
                                                                                    <b-button size="sm"
                                                                                        variant="outline-secondary"
                                                                                        @click="line.description = ''"
                                                                                        :disabled="line.description == ''">
                                                                                        <i class="fa fa-remove"></i>
                                                                                    </b-button>
                                                                                </b-input-group-append>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="sl_columns.includes('slac')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect placeholder="Select slac..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="line.slac"
                                                                                    :clearable="true" :multiple="false"
                                                                                    :async="true"
                                                                                    :load-options="treeselect_loadSLAC"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    :disabled="readonly" class="h-20px"
                                                                                    @select="edited = true">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>
                                                                    <td v-if="sl_columns.includes('eventcode')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect
                                                                                    placeholder="Select event..."
                                                                                    v-model="line.eventcode"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadEvent"
                                                                                    searchPromptText="Type at least 4 chars..."
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    class="h-20px"
                                                                                    @select="edited = true">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="sl_columns.includes('nlcode')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect instanceId="nlcode"
                                                                                    v-model="line.nlcode"
                                                                                    :clearable="true"
                                                                                    :disabled="index == 0"
                                                                                    :options="nlcode_options"
                                                                                    :multiple="false" class="h-20px"
                                                                                    @select="edited = true">
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="sl_columns.includes('amount')">
                                                                        <b-form-group class="mb-3px">
                                                                            <b-input-group>
                                                                                <b-form-input size="sm"
                                                                                    v-model="line.amount"
                                                                                    placeholder="Amount"
                                                                                    class="text-right"
                                                                                    :formatter="nocomma"></b-form-input>
                                                                                <b-input-group-append>
                                                                                    <b-button size="sm"
                                                                                        variant="outline-secondary"
                                                                                        @click="line.amount = '0.00'"
                                                                                        :disabled="line.amount == '0.00'">
                                                                                        <i class="fa fa-remove"></i>
                                                                                    </b-button>
                                                                                </b-input-group-append>
                                                                            </b-input-group>

                                                                        </b-form-group>
                                                                    </td>

                                                                    <td :id="'lines-del_' + index" class="w-30px"
                                                                        style="padding-left:5px !important;">
                                                                        <b-input-group v-if="index > 0"
                                                                            class="m-auto w-15px">
                                                                            <i class="fa fa-trash text-danger font-14px"
                                                                                @click="delLine(index + 1)"></i>
                                                                            <b-tooltip :target="'lines-del_' + index"
                                                                                placement="top">Del
                                                                                line</b-tooltip>

                                                                        </b-input-group>
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </b-col>
                                            </b-row>

                                            <b-row class="mt-1">
                                                <b-col style="margin-left:10px">
                                                    <i class="fa fa-plus-square-o text-primary font-20px"
                                                        @click="addLine"></i>
                                                </b-col>
                                            </b-row>

                                            <!-- <b-row class="mt-3">
                                                                                       <b-col cols="12" sm="6" md="4" xl="3">
                                                <b-form-group label="Transaction Type" label-for="prefix"
                                                    label-cols="12">
                                                    <treeselect type="number" v-model="prefix" :clearable="false"
                                                        :options="prefix_options"></treeselect>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="3">
                                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                    <treeselect placeholder="Select slac..."
                                                        searchPromptText="Type at least 3 chars..." v-model="slac"
                                                        :multiple="true" :clearable="true" :async="true"
                                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                                        :flatten-search-results="true" :disable-branch-nodes="true"
                                                        :matchKeys="['id']" search-nested>
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>
                                                </b-form-group>
                                            </b-col>
 
                                            <b-col cols="3"> <b-form-group label="Amount" label-for="amount"
                                                    label-cols="12">
                                                    <b-input-group class="smallinputs">
                                                        <b-form-input type="text" v-model="item.amount"
                                                            placeholder="Amount" size="sm"
                                                            :disabled="true"></b-form-input>
                                                        <b-input-group-append class="h-22px">
                                                            <b-button class="sm" size="sm" variant="outline-secondary"
                                                                @click="item.amount = '0.00'" :disabled="true">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group></b-col>
                                        </b-row> -->

                                        </b-tab>
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-2 mr-1">
                                                    <i class="fa fa-pie-chart mr-1"></i>
                                                    Costs
                                                </div>
                                            </template>
                                            <b-row class="mt-2 px-3">
                                                <!-- {{ bl_lines }} -->

                                                <div
                                                    class="mt-0 mb-1 text-center nested availtable datatable smallinputs etable">
                                                    <table
                                                        class="w-100pct table b-table table-striped table-hover table-sm mb-1"
                                                        style="table-layout:fixed">
                                                        <!-- <tr class="header-dark"> -->
                                                        <tr class="header-primary text-white">

                                                            <td colspan="2" class="text-center w-30px">Lines </td>

                                                            <td class="text-center w-35px"
                                                                v-if="bl_columns.includes('prefix')">
                                                                Type
                                                            </td>

                                                            <td class="text-right w-100px"
                                                                v-if="bl_columns.includes('description')">
                                                                Description
                                                            </td>

                                                            <td class="text-center w-80px"
                                                                v-if="bl_columns.includes('blac')">
                                                                BL A/C
                                                            </td>

                                                            <td class="text-center w-80px"
                                                                v-if="bl_columns.includes('eventcode')">
                                                                Event
                                                            </td>

                                                            <td class="text-center w-110px"
                                                                v-if="sl_columns.includes('nlcode')">
                                                                NL Code
                                                            </td>

                                                            <td class="text-center w-50px"
                                                                v-if="bl_columns.includes('amount')">
                                                                <span
                                                                    v-html="value.amount > 0 ? 'Received' : 'Spent'"></span>
                                                            </td>

                                                            <td role="columnheader" scope="col" aria-colindex="1"
                                                                class="table-b-table-default text-center w-25px">
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td colspan="5"></td>
                                                        </tr>
                                                        <tbody role="rowgroup">
                                                            <tr v-for="(line, index) in bl_lines" :key="index">

                                                                <td class="">
                                                                    <span class="small text-primary">{{ index + 1
                                                                        }}.</span>
                                                                </td>
                                                                <td class="">
                                                                    <!-- <i :class="line.icon" class="mr-2"></i> -->
                                                                    <i class="fa fa-pie-chart"></i>
                                                                </td>

                                                                <td v-if="bl_columns.includes('prefix')">
                                                                    <b-form-group class="">
                                                                        <b-input-group>
                                                                            <treeselect instanceId="type"
                                                                                v-model="line.prefix" :clearable="true"
                                                                                :options="prefix_options"
                                                                                :multiple="false" class="h-20px"
                                                                                @select="edited = true">
                                                                            </treeselect>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </td>

                                                                <td v-if="bl_columns.includes('description')">
                                                                    <b-form-group class="mb-3px">
                                                                        <b-input-group>
                                                                            <b-form-input size="sm"
                                                                                v-model="line.description"
                                                                                placeholder="Description"
                                                                                class="text-left"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="line.description = ''"
                                                                                    :disabled="line.description == ''">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </td>

                                                                <td v-if="bl_columns.includes('blac')">
                                                                    <b-form-group class="">
                                                                        <b-input-group>
                                                                            <treeselect
                                                                                searchPromptText="Type at least 3 chars..."
                                                                                v-model="line.blac" :clearable="true"
                                                                                :multiple="false" :async="true"
                                                                                :load-options="treeselect_loadBLAC"
                                                                                :show-count="true"
                                                                                :flatten-search-results="true"
                                                                                :disable-branch-nodes="true"
                                                                                :matchKeys="['id']" search-nested
                                                                                :disabled="readonly" class="h-20px"
                                                                                @select="edited = true">
                                                                                <div slot="value-label"
                                                                                    slot-scope="{ node }">
                                                                                    {{ node.raw.id }}
                                                                                </div>
                                                                            </treeselect>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </td>
                                                                <td v-if="bl_columns.includes('eventcode')">
                                                                    <b-form-group class="">
                                                                        <b-input-group>
                                                                            <treeselect placeholder="Select event..."
                                                                                v-model="line.eventcode"
                                                                                :clearable="true" :async="true"
                                                                                :load-options="treeselect_loadEvent"
                                                                                searchPromptText="Type at least 4 chars..."
                                                                                :show-count="true"
                                                                                :flatten-search-results="true"
                                                                                :disable-branch-nodes="true"
                                                                                :matchKeys="['id']" search-nested
                                                                                class="h-20px" @select="edited = true">
                                                                                <div slot="value-label"
                                                                                    slot-scope="{ node }">
                                                                                    {{ node.raw.id }}
                                                                                </div>
                                                                            </treeselect>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </td>

                                                                <td v-if="bl_columns.includes('nlcode')">
                                                                    <b-form-group class="">
                                                                        <b-input-group>
                                                                            <treeselect instanceId="nlcode"
                                                                                v-model="line.nlcode" :clearable="true"
                                                                                :disabled="index == 0"
                                                                                :options="nlcode_options"
                                                                                :multiple="false" class="h-20px"
                                                                                @select="edited = true">
                                                                            </treeselect>
                                                                        </b-input-group>
                                                                    </b-form-group>
                                                                </td>

                                                                <td v-if="bl_columns.includes('amount')">
                                                                    <b-form-group class="mb-3px">
                                                                        <b-input-group>
                                                                            <b-form-input size="sm"
                                                                                v-model="line.amount"
                                                                                placeholder="Amount" class="text-right"
                                                                                :formatter="nocomma"></b-form-input>
                                                                            <b-input-group-append>
                                                                                <b-button size="sm"
                                                                                    variant="outline-secondary"
                                                                                    @click="line.amount = '0.00'"
                                                                                    :disabled="line.amount == '0.00'">
                                                                                    <i class="fa fa-remove"></i>
                                                                                </b-button>
                                                                            </b-input-group-append>
                                                                        </b-input-group>

                                                                    </b-form-group>
                                                                </td>

                                                                <td :id="'lines-del_' + index" class="w-30px"
                                                                    style="padding-left:5px !important;">
                                                                    <b-input-group v-if="index > 0"
                                                                        class="m-auto w-15px">
                                                                        <i class="fa fa-trash text-danger font-14px"
                                                                            @click="delLine(index + 1)"></i>
                                                                        <b-tooltip :target="'lines-del_' + index"
                                                                            placement="top">Del
                                                                            line</b-tooltip>

                                                                    </b-input-group>
                                                                </td>

                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <b-row class="mt-1">
                                                    <b-col style="margin-left:10px">
                                                        <i class="fa fa-plus-square-o text-primary font-20px"
                                                            @click="addLine"></i>
                                                    </b-col>
                                                </b-row>
                                            </b-row>
                                        </b-tab>

                                        <b-tab v-if="1 == 0">
                                            <template #title>
                                                <div class="badgecontainer pr-2 mr-1">
                                                    <i class="fa fa-link"></i>
                                                    Match
                                                </div>
                                            </template>
                                            <b-row class="pt-2 pb-1">
                                                <b-col class="strong text-1x pt-2">Paste your matches or amend the
                                                    match
                                                    list
                                                    here</b-col>
                                            </b-row>
                                            <b-row>
                                                <!-- sm="6" md="4" xl="3" -->
                                                <b-col cols="12">
                                                    <b-form-group label-cols="12"
                                                        :label="'Count [ ' + invoiceno.length + ' ]'" label-size="sm"
                                                        class="mb-0 text-right text-primary strong">
                                                        <!-- <b-input-group class="treeselect_all justify-content-end pr-2px">
                            <span style="padding-top: 0.3em" class="text-primary" id="reflike-tooltip">Like</span>
                            <b-form-checkbox id="reflike" v-model="reflike_visible" class="z-0">
                            </b-form-checkbox>
                        </b-input-group> -->
                                                        <b-input-group>
                                                            <b-form-tags input-id="reflist" v-model="invoiceno"
                                                                tag-variant="primary" separator=" ,;"
                                                                placeholder="Paste Ref List (IA519826,IA519827,...)"
                                                                size="sm" class="h-29" add-button-text="+" add-on-change
                                                                remove-on-delete
                                                                add-button-variant="outline-primary"></b-form-tags>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="invoiceno = []">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-tab>
                                        <b-tab v-if="1 == 0">
                                            <template #title>
                                                <div class="badgecontainer pr-2 mr-1">
                                                    <i class="fa fa-check-square-o"></i>
                                                    Due
                                                </div>
                                            </template>

                                            <b-row class="pt-2 pb-1">
                                                <b-col class="strong text-1x pt-2">To see the transactions due on
                                                    account
                                                    click
                                                    Go</b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable" refid="sltransactions"
                                                        :icon="sltransactions.icon" :busy="sltransactions.busy"
                                                        :tools="sltransactions.tools" :badges="sltransactions.badges"
                                                        :fields="sltransactions.fields" :items="sltransactions.items"
                                                        :offset="sltransactions.offset" :limit="sltransactions.limit"
                                                        :showpages="true">
                                                    </d-table>
                                                </b-col>
                                            </b-row>

                                        </b-tab>
                                        <b-tab v-if="1 == 0">
                                            <template #title>
                                                <div class="badgecontainer pr-2 mr-1">
                                                    <i class="fa fa-list"></i>
                                                    Summary
                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col>
                                                    <b-form-textarea v-model="summary" placeholder="Actions" rows="8"
                                                        :disabled="true"></b-form-textarea>
                                                </b-col>
                                            </b-row>



                                        </b-tab>
                                    </b-tabs>
                                </b-col>
                            </b-row>
                        </b-overlay>

                        <b-row class="mt-2 smallinputs justify-content-start justify-content-xl-between"
                            v-if="payindex == 0 || payindex == 1">
                            <b-col cols="12" sm="12" md="12" xl="6">
                                <b-row>
                                    <b-col class="text-right w-120px pr-2">
                                        <b-form-checkbox class="z-0 mr-0" v-model="allocateonly" name="allocateonly">
                                            <span class="pl-0">Allocate only</span>
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col class="ml-0 pl-0">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="referenceno"
                                                    placeholder="ref"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button class="h-22px" size="sm" variant="outline-secondary"
                                                        @click="referenceno = ''"
                                                        :disabled="!allocateonly || referenceno == ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                    <i class="fa fa-info-circle text-black mt-1 pl-2"
                                                        :id="value.id + '_allocate_pp'"></i>
                                                    <b-tooltip :target="value.id + '_allocate_pp'" triggers="hover"
                                                        placement="top">Enter
                                                        multiple PP,PP refs to sum to match the money
                                                        amount. Uses commas or spaces as transaction separators.</b-tooltip>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" sm="12" md="12" xl="6">
                                <b-row>
                                    <b-col>
                                        <b-row>
                                            <b-col class="text-right w-100px  ">
                                                <i class="fa fa-search text-primary ml-2 mr-2 mt-1"></i>
                                                Search
                                            </b-col>
                                            <b-col class="ml-0 px-0 mr-3">
                                                <b-form-group class="mb-3px" :disabled="!allocateonly">
                                                    <treeselect v-if="payindex == 0" placeholder="Select slac..."
                                                        searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                        :clearable="true" :async="true"
                                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                                        :flatten-search-results="true" :disable-branch-nodes="true"
                                                        :matchKeys="['id']" search-nested>
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>
                                                    <treeselect v-if="payindex == 1" placeholder="Select blac..."
                                                        searchPromptText="Type at least 3 chars..." v-model="item.blac"
                                                        :clearable="true" :async="true"
                                                        :load-options="treeselect_loadBLAC" :show-count="true"
                                                        :flatten-search-results="true" :disable-branch-nodes="true"
                                                        :matchKeys="['id']" search-nested>
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12" sm="12" md="6" xl="6">
                                        <b-row>
                                            <b-col class="ml-2">
                                                <!-- <b-col class="w-270px pr-0"> -->
                                                <b-form-group class="mb-3px" :disabled="!allocateonly">
                                                    <treeselect v-if="payindex == 0" class="h-20px"
                                                        placeholder="Type PP ref or amount..."
                                                        searchPromptText="Type at least 4 chars..."
                                                        v-model="referenceno" :async="true"
                                                        :load-options="treeselect_loadSLInvoiceno" :show-count="true"
                                                        :multiple="false" :flatten-search-results="true"
                                                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>
                                                    <treeselect v-if="payindex == 1" class="h-20px"
                                                        placeholder="Type PP ref or amount..."
                                                        searchPromptText="Type at least 4 chars..."
                                                        v-model="referenceno" :async="true"
                                                        :load-options="treeselect_loadBLInvoiceno" :show-count="true"
                                                        :multiple="false" :flatten-search-results="true"
                                                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            {{ node.raw.id }}
                                                        </div>
                                                    </treeselect>

                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="auto" class="pl-0">
                                                <i class="fa fa-info-circle text-black"
                                                    :id="value.id + '_allocate_info'"></i>
                                                <b-tooltip :target="value.id + '_allocate_info'" triggers="hover"
                                                    placement="top">Select
                                                    a A/C to
                                                    filter a transaction reference, you may use the first characters of
                                                    the ref
                                                    or you
                                                    can type
                                                    in the amount.</b-tooltip>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-col>

                        </b-row>


                        <!-- <b-row class="mt-2 smallinputs justify-content-around">
                            <b-col class="w-300px">
                                <b-row no-gutters>
                                    <b-col cols="auto" class="text-right mr-2">
                                        <b-form-checkbox class="z-0 mr-0" v-model="allocateonly" name="allocateonly">
                                            <span class="pl-0">Allocate only</span>
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col class="w-150px">
                                        <b-form-group class="mb-3px" style="">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="referenceno"
                                                    placeholder="ref"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button class="h-22px" size="sm" variant="outline-secondary"
                                                        @click="referenceno = ''"
                                                        :disabled="!allocateonly || referenceno == ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="12" sm="6">
                                <b-row class="justify-content-center">
                                    <b-col class="text-right w-100px">
                                        <i class="fa fa-search text-primary ml-2 mr-2 mt-1"></i>
                                        Search
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" class="ml-0 pl-0">
                                        <b-form-group class="mb-3px" :disabled="!allocateonly">
                                            <treeselect placeholder="Select slac..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                :show-count="true" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>                              
                                    <b-col class="w-270px">
                                        <b-form-group class="mb-3px" :disabled="!allocateonly">
                                            <treeselect class="h-20px" placeholder="Type PP ref or amount..."
                                                searchPromptText="Type at least 4 chars..." v-model="referenceno"
                                                :async="true" :load-options="treeselect_loadSLInvoiceno"
                                                :show-count="true" :multiple="false" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row> -->
                    </b-col>

                </b-row>
            </div>
            <!-- <b-row class="border-bottom pt-2 pb-3">
                <b-col>
                    <b-row>
                        <b-col class="strong text-2x pt-2">2. View your selected entries. Add new entries, as
                            needed.</b-col> -->
            <!-- <b-col class="text-right pr-0">
                            <b-nav-item-dropdown size="sm" text="New Transactions" right class="list-none">
                                <b-dropdown-item href="#">X</b-dropdown-item>
                                <b-dropdown-item href="#">Y</b-dropdown-item>
                            </b-nav-item-dropdown>
                        </b-col> -->
            <!-- </b-row> -->
            <!-- <b-row no-gutters>
                        <b-col>
                            <b-form-textarea v-model="item.transactions"
                                placeholder="No transactions have been selected" rows="3"></b-form-textarea>
                        </b-col>
                    </b-row> -->

            <!-- <b-row class="mt-1">
                        <b-col cols="12" sm="12">
                            <b-form-group label-cols="12" label="Transactions" label-size="sm" class="mb-0">
                                <b-input-group>
                                    <b-form-tags input-id="transactions" v-model="matchlist" tag-variant="primary"
                                        separator=" ,;/" placeholder="" size="sm" class="h-29" add-button-text="+"
                                        add-on-change remove-on-delete
                                        add-button-variant="outline-primary"></b-form-tags>
                                    <b-input-group-append>
                                        <b-button size="sm" variant="outline-secondary"
                                            @click="item.transactions = null">
                                            <i class="fa fa-remove"></i>
                                        </b-button>
                                        <b-button size="sm" variant="outline-primary"
                                            @click="load_data('transactions')">
                                            <i :class="load_busy ? 'fa fa-spinner fa-spin' : 'fa fa-upload'"></i>
                                            Add To Matched
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row> -->

            <!-- </b-col>
            </b-row> -->



            <b-card-footer class="mx-1 nopadding border-none mt-2">
                <b-row no-gutters>
                    <b-col cols="auto" class="text-left">
                        <!-- :disabled="!(parseFloat(item.amount) == parseFloat(invoiceno_due))" -->
                        <b-button squared size="sm" variant="primary"
                            :disabled="postit_disabled || parseFloat(this.difference) != 0 || !(this.referenceno || this.sl_lines[0].slac || this.bl_lines[0].blac)"
                            @click="save_it">
                            <i class="fa fa-check pr-1"></i>
                            Post It
                        </b-button>
                    </b-col>
                    <b-col  class="text-left ml-2 mt-1">
                        <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                        </div>
                        <div v-else>
                            <span class="truncate-750" v-html="message"></span>
                        </div>
                    </b-col>
                    <b-col cols="auto" class="text-right">
                        <!-- <b-button squared size="sm" variant="secondary" @click="close_it">
                            <i class="fa fa-chevron-left pr-1"></i>
                            Back
                        </b-button> -->
                        <b-link v-if="!value.reconciled" @click="close_it">Close It</b-link>
                        <i @click="close_it" class="text-primary strong ml-1 fa fa-long-arrow-up"></i>
                    </b-col>
                </b-row>
            </b-card-footer>
            <div class="px-3 mt-3">
                <component :is="selectedComponent" :search="search" />
            </div>
        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";

import BankingsRules from "../private/Apps/Accounts/Components/BankingsRules.vue";

export default {
    name: "i-reconcile",
    components: {
        BankingsRules
    },
    async mounted() {
        console.log("i-reconcile mounted");

        // this.banking_options = metadata.banking
        try {
            const response = await this.$apollo.query({
                query: gql`
                query nlcodes {
                    nlcodes {
                        id
                        label
                    }
                }
            `,
            });
            this.nlcode_options = response.data.nlcodes;
        } catch (error) {
            console.log(error);
        }
        this.vat_options = [
            { id: "0", label: "0 | No VAT" },
            { id: "20", label: "20% | Standard" }
        ]
    },
    data() {
        return {
            tabindex: 1,
            payindex: 0,
            summary: "",
            message: "",
            busy: false,
            readonly: false,
            postit_disabled: false,
            popoverStatement: false,
            popoverMatch: false,
            matchesShow: false,
            load_busy: false,
            edited: false,

            prefix: "PP",
            prefix_options: [
                {
                    id: "PP",
                    label: "PP",
                },
                {
                    id: "PC",
                    label: "PC",
                },
                {
                    id: "PA",
                    label: "PA",
                },
            ],
            page: 1,
            item: {
                ref: "",
                nlcode: null,
                who: "",
                vat: "0"
            },
            allocateonly: false,
            referenceno: null,
            referenceno_lookup: [],
            summary: "A new PP transaction will be created.",
            matchlist: [],
            slac: [],
            invoiceno: [],
            invoiceno_amount: "0.00",
            invoiceno_due: "0.00",
            spentorreceived: 'spent',
            data: null,
            bankingslines: [],
            banking_options: [],
            nlcode_options: [],
            vat_options: [],
            sl_columns: ['prefix', 'description', 'slac', 'eventcode', 'nlcode', 'amount'],
            sl_lines: [],
            bl_columns: ['prefix', 'description', 'blac', 'eventcode', 'nlcode', 'amount'],
            bl_lines: [],
            transactions: {
                busy: false,
                showfilter: false,
                debounce: 500,
                title: "Transactions",
                icon: "fa fa-file-text-o text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                showreceived: false,
                ledger: "Sales",
                toolbarlibrary: [],
                edit: false,
                tools: "go",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "dateref",
                        label: "Date",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "yourref",
                        label: "Your Ref/PO",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = value.split(" ")[0];
                        //   }
                        //   return result;
                        // },
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value / 1000).format("DD/MM/YY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "fees",
                        label: "Fees",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "saletotal",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "due",
                        label: "Due",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "refcredit",
                        label: "Cr Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "lines",
                        label: "Lines",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "credit",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = value.split(" ")[0];
                        //   }
                        //   return result;
                        // },
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
                        //   }
                        //   return result;
                        // },
                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-100px w-sm-100pct",
                    // },
                ],
                // fields: [
                //     {
                //         key: "selected",
                //         label: "...",
                //         class: "text-center",
                //     },
                //     {
                //         key: "icon",
                //         label: "",
                //         class: "text-right w-50px",
                //     },
                //     {
                //         key: "date_at",
                //         label: "Date",
                //         sortable: true,
                //         formatter: (value, key, item) => {
                //             let result = "";
                //             if (value) {
                //                 result = this.$moment
                //                     .unix(value / 1000)
                //                     .utc(false)
                //                     .format("DD/MM/YYYY");
                //             }
                //             return result;
                //         },
                //     },
                //     {
                //         key: "name",
                //         label: "Name",
                //         class: "text-center",
                //         sortable: true,
                //     },
                //     {
                //         key: "reference",
                //         label: "Reference",
                //         class: "text-center",
                //         sortable: true,
                //     },
                //     // {
                //     //     key: "payee",
                //     //     label: "Payee",
                //     //     class: "text-center",
                //     //     formatter: (value, key, item) => {
                //     //         let result = value;
                //     //         if (result) {
                //     //             if (result.length > 30) {
                //     //                 result = result.slice(0, 27) + "...";
                //     //             }
                //     //         }
                //     //         return result;
                //     //     },
                //     // },
                //     // {
                //     //     key: "description",
                //     //     label: "Description",
                //     //     class: "text-center",
                //     //     sortable: true,
                //     // },

                //     // {
                //     //     key: "amount",
                //     //     label: "Amount",
                //     //     sortable: true,
                //     //     class: "text-right",
                //     //     totalled: true,
                //     //     total: 0,
                //     // },
                //     {
                //         key: "spent",
                //         label: "Spent",
                //         sortable: true,
                //         class: "text-right",
                //         totalled: true,
                //         total: 0,
                //     },
                //     {
                //         key: "received",
                //         label: "Received",
                //         sortable: true,
                //         class: "text-right",
                //         totalled: true,
                //         total: 0,
                //     },
                //     // {
                //     //     key: "balance",
                //     //     label: "Balance",
                //     //     sortable: true,
                //     //     class: "text-right",
                //     // },
                //     // {
                //     //     key: "source",
                //     //     label: "Source",
                //     //     sortable: true,
                //     //     class: "text-center",
                //     // },
                //     // {
                //     //     key: "status",
                //     //     label: "Status",
                //     //     sortable: true,
                //     //     class: "text-center",
                //     // },
                //     // {
                //     //     key: "updated_by",
                //     //     label: "Updated By",
                //     //     sortable: true,
                //     //     class: "text-center d-none d-sm-table-cell",
                //     // },
                //     // {
                //     //     key: "updated_at",
                //     //     label: "Updated At",
                //     //     sortable: true,
                //     //     class: "text-center d-none d-sm-table-cell",
                //     // },
                //     {
                //         key: "actions",
                //         label: "Actions",
                //         class: "actions w-110px",
                //     },
                // ],
                // badges: [
                //     // {
                //     //     key: "type",
                //     //     type: "badge",
                //     //     debit: "danger",
                //     //     credit: "primary",
                //     // },
                //     // {
                //     //     key: "source",
                //     //     type: "badge",
                //     //     imported: "secondary",
                //     //     feed: "orange",
                //     // },
                //     // {
                //     //     key: "status",
                //     //     type: "badge",
                //     //     unreconciled: "orange",
                //     //     reconciled: "primary",
                //     // },
                // ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: [],

            },
            sltransactions: {
                busy: false,
                showfilter: false,
                debounce: 500,
                title: "Sales",
                icon: "fa fa-wpforms text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                showreceived: false,
                toolbarlibrary: [],
                edit: false,
                tools: "go,filter,export",

                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center w-80px",
                    },
                    {
                        key: "dateref",
                        label: "Date",
                        sortable: true,
                        class: "text-center",
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = this.$moment
                        //       .unix(value / 1000)
                        //       .format("DD/MM/YYYY HH:mm:ss");
                        //   }
                        //   return result;
                        // },
                    },
                    {
                        key: "yourref",
                        label: "Your Ref/PO",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = value.split(" ")[0];
                        //   }
                        //   return result;
                        // },
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value / 1000).format("DD/MM/YY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "fees",
                        label: "Fees",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "saletotal",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "due",
                        label: "Due",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "refcredit",
                        label: "Cr Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "lines",
                        label: "Lines",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "credit",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",

                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-100px w-sm-100pct",
                    // },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: [],

            },
            bltransactions: {
                busy: false,
                showfilter: false,
                debounce: 500,
                title: "Costs",
                icon: "fa fa-pie-chart text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                showreceived: false,
                toolbarlibrary: [],
                edit: false,
                tools: "go,filter,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "dateref",
                        label: "Date",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "blac",
                        label: "BL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "ticketno",
                        label: "TicketNo",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 10) {
                                    result = result.slice(0, 12) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "paid",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "due",
                        label: "Due",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    // {
                    //   key: "refcredit",
                    //   label: "Cr Ref",
                    //   sortable: true,
                    //   class: "d-none d-sm-table-cell",
                    // },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-100px w-sm-100pct",
                    // },
                ],
                badges: [
                    {
                        key: "type",
                        type: "badge",
                        Refund: "white",
                        Credit: "danger",
                        Invoice: "success"
                    },
                ],
                item: {},
                items: [],
                selected: [],

            },
            ticketsrepository: {
                busy: false,
                showfilter: false,
                debounce: 500,
                title: "Tickets",
                icon: "fa fa-ticket text-primary",
                page: 1,
                offset: 0,
                limit: 15,
                showreceived: false,
                toolbarlibrary: [],
                edit: false,
                tools: "go,filter,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    {
                        key: "dateissued",
                        label: "Issued",
                        sortable: true,
                        class: "text-center",
                        // formatter: (value, key, item) => {
                        //   let result = "";
                        //   if (value) {
                        //     result = value.split(" ")[0];
                        //   }
                        //   return result;
                        // },
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "carrier_id",
                        label: "Al",
                        sortable: true,
                        class: "d-none d-xl-table-cell text-center",
                    },

                    {
                        key: "ticketno",
                        label: "Ticket No",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "passenger",
                        label: "Name",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = value.split(" ")[0];
                            }
                            return result;
                        },
                    },
                    {
                        key: "routing",
                        label: "Routing",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 13) {
                                    result = result.slice(0, 12) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "flightno",
                        label: "FlightNo",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 14) {
                                    result = result.slice(0, 14) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "class",
                        label: "Class",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                    },
                    // {
                    //   key: "seatno",
                    //   label: "Seat",
                    //   sortable: true,
                    //   class: "d-none d-lg-table-cell text-center",
                    //   formatter: (value, key, item) => {
                    //     let result = value;
                    //     if (result) {
                    //       if (result.length > 7) {
                    //         result = result.slice(0, 7) + "...";
                    //       }
                    //     }
                    //     return result;
                    //   },
                    // },
                    // {
                    //   key: "fare_type",
                    //   label: "Fare Type",
                    //   sortable: true,
                    //   class: "text-center",
                    // },
                    {
                        key: "fare",
                        label: "Fare",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "tax",
                        label: "Tax",
                        sortable: true,
                        class: "text-right",
                        totalled: true,
                        total: 0,
                    },
                    // {
                    //   key: "fee",
                    //   label: "Fee",
                    //   sortable: true,
                    //   class: "text-right",
                    //   totalled: true,
                    //   total: 0,
                    // },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //   key: "branch",
                    //   label: "Branch",
                    //   sortable: true,
                    // },
                    {
                        key: "agent",
                        label: "Agent",
                        sortable: true,
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-center",
                    },
                    // {
                    //   key: "lines",
                    //   label: "#Sec",
                    //   sortable: true,
                    // },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-130px",
                    // },
                ],
                badges: [
                    {
                        key: "carrier_id",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "ticketno",
                        type: "pill",
                        class: "orange",
                    },
                    {
                        key: "class",
                        type: "pill",
                        class: "purple",
                        title: "classname",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "lines",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "type",
                        type: "badge",
                        Charter: "teal",
                        Ticket: "primary",
                        Reissue: "primary",
                        Void: "white",
                        Refund: "white",
                        EMD: "purple",
                        Lowcost: "pink"
                    },
                ],
                item: {},
                items: [],
                selected: [],

            },
            selectedComponent: null,
            search: {
                //event: null,

            },
        };
    },
    props: {
        value: { type: Object, required: true },
        title: { type: String, default: "" },
    },
    computed: {
        matchexact() {
            if (this.match) {
                if (Math.abs(this.match.amount) == Math.abs(this.item.amount)) {
                    return true
                }
            }
            return false
        },
        match() {
            if (this.value.reconciled) {
                return this.value.reconciled[0]
            }
            if (this.item.matches) {
                if (this.item.matches.length > 0) {
                    let matching = this.item.matches[0]
                    if (matching.ref) {
                        this.matchlist = this.item.matches[0].ref.split(",")
                    } else {
                        this.matchlist = []
                    }
                } else {
                    this.matchlist = []
                }
                return this.item.matches[0]
            }
            return null
        },
        paymentdirection() {
            if (this.spentorreceived == 'received') {
                return 'Payment Received'
            } else {
                return 'Payment Spent'
            }
        },
        matched_label() {
            if (this.value.accountno.includes('LLOYDS')) {
                return 'Posted'
            } else if (this.value.accountno.includes('BSP')) {
                return 'Matched'
            } else {
                return 'Posted'
            }
        },
        difference() {
            let value = 0
            switch (this.payindex) {
                case 0:
                    value = Math.abs(parseFloat(this.item.amount)) - this.sl_lines.filter(item => item.amount && item.prefix != 'PA').reduce((sum, item) => (sum + Math.abs(parseFloat(item.amount))), 0)
                    break;
                case 1:
                    value = Math.abs(parseFloat(this.item.amount)) - this.bl_lines.filter(item => item.amount && item.prefix != 'PA').reduce((sum, item) => (sum + Math.abs(parseFloat(item.amount))), 0)
                    break;
            }
            return Math.abs(value).toFixed(2)
        }
    },
    watch: {
        value: {
            immediate: true,
            async handler(newVal, oldVal) {

                this.matchesShow = false;
                this.tabindex = 1;
                this.postit_disabled = false
                this.allocateonly = false
                this.slac = null
                this.blac = null
                this.referenceno = null
                this.message = null

                this.invoiceno = []

                if (parseFloat(newVal.amount) >= 0) {
                    this.spentorreceived = 'received'
                } else {
                    this.spentorreceived = 'spent'
                }

                this.item = {
                    ref: "",
                    nlcode: null,
                    who: "",
                    vat: "0"
                }

                let variables = {
                    id: this.value.id
                }
                try {
                    const response = await this.$apollo.query({
                        query: gql`
                    query bankingslines (
                            $id: String
                        ) {
                        bankingslines (
                            id: $id
                        ) {
                            id
                            type
                            description
                            reference
                            analysis
                            amount
                            notes
                            matches {
                                id
                                type
                                who
                                what
                                why
                                ref
                                date_at
                                amount
                                difference
                                bankinglines_id
                                SLTransactions {
                                    id
                                    date_at
                                    entry                
                                    credit
                                    yourref
                                    agent
                                    to
                                    slac
                                    eventcode
                                    travel_at
                                    fees
                                    saletotal
                                    due
                                    refcredit
                                    lines
                                    datepaid
                                    invoiceno
                                    updated_at
                                    updated_by
                                }
                            }
                        }
                    }
                `,
                        variables
                    });

                    this.item = response.data.bankingslines[0]
                    if (this.item.matches.length > 0) {
                        this.tabindex = 0
                        this.sltransactions.items = this.item.matches[0].SLTransactions
                    } else {
                        this.tabindex = 1
                    }

                    // if (this.value.metadata) {
                    //     let metadata = JSON.parse(this.value.metadata)
                    //     this.banking_options = metadata.banking
                    //     this.nlcode_options = metadata.nlcodes
                    //     this.vat_options = metadata.vatcodes
                    // }

                    if (this.value.reconciled) {
                        this.tabindex = 0
                    }

                    this.sl_lines = [
                        {
                            prefix: 'PP',
                            description: 'BACS ' + this.$moment.unix(this.value.date_at * .001).utc(true).format('DD.MM.YY'),
                            slac: null,
                            eventcode: null,
                            nlcode: "1100",
                            amount: Math.abs(this.value.amount).toFixed(2)
                        },
                    ]
                    this.bl_lines = [
                        {
                            prefix: 'PP',
                            description: 'BACS ' + this.$moment.unix(this.value.date_at * .001).utc(true).format('DD.MM.YY'),
                            blac: null,
                            eventcode: null,
                            nlcode: "1200",
                            amount: Math.abs(this.value.amount).toFixed(2)
                        },
                    ]


                } catch (error) {
                    console.log(error);
                }
                if (this.item.matches[0]) {
                    if (this.item.matches[0].ref) {
                        this.invoiceno = this.item.matches[0].ref.split(',')
                    }
                }
                if (this.match) {
                    if (this.match.who) {
                        this.slac = this.match.who
                    }
                }
            }
        },
        tabindex: {
            immediate: true,
            async handler(newVal, oldVal) {

            }
        },
        matchesShow: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.tabindex = 0
                }
            }
        },
        invoiceno: {
            immediate: true,
            async handler(newVal, oldVal) {
                // if (newVal) {

                //     let variables = {
                //         invoiceno: newVal.join(","),
                //     };
                //     if (variables.invoiceno) {
                //         try {
                //             const response = await this.$apollo.query({
                //                 query: gql`
                //                 query SL_matches(
                //                     $invoiceno: String              
                //                 ) {
                //                     SL_matches2(invoiceno: $invoiceno) {
                //                     slac,
                //                     amount
                //                     due
                //                     }
                //             }
                //             `,
                //                 variables,
                //             });
                //             this.invoiceno_amount = "0.00"
                //             this.invoiceno_due = "0.00"
                //             this.difference = 0

                //             if (response.data.SL_matches2) {
                //                 if (response.data.SL_matches2.slac) {
                //                     this.slac = response.data.SL_matches2.slac.split(",")

                //                     this.summary = this.prefix + " transactions will be created for: " + this.slac.join(",")
                //                 }

                //                 this.invoiceno_amount = response.data.SL_matches2.amount
                //                 this.invoiceno_due = response.data.SL_matches2.due

                //                 if (parseFloat(this.item.amount) == (parseFloat(this.invoiceno_due) - parseFloat(this.item.amount))) {
                //                     this.difference = 0
                //                 } else {
                //                     this.difference = parseFloat(this.invoiceno_due) - parseFloat(this.item.amount)
                //                 }

                //             }

                //         } catch (error) {
                //         }
                //     }

                // }
            }
        },
        referenceno: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.allocateonly = true
                } else {
                    this.allocateonly = false
                }
            }
        },
        referenceno_lookup: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.referenceno = newVal[0]
                }
            }
        },
        amount: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (parseFloat(newVal)) {
                    this.lines[0].amount = newVal
                }
            }
        },
        async showreceived() {
            await this.transactions_load(0);
        },
        async description() {
            await this.transactions_load(0);
        },
        async reference() {
            await this.transactions_load(0);
        },
        async amount() {
            await this.transactions_load(0);
        },
    },
    methods: {
        async bankingsline_save(ss) {
            let variables = {
                rows: this.cleanit(ss),
            };
            delete variables.rows[0].matches
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation bankingslines_save(
                        $rows: [BankingLine_input]               
                    ) {
                        bankingslines_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

        },
        async transactions_load(offset, limit, page) {

            let state = this.transactions;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            // let variables = {
            //     offset: state.offset,
            //     limit: state.limit,
            //     sortno: this.sortno,
            //     accountno: this.accountno,
            //     accountname: this.accountname,
            //     bankname: this.bankname,
            // };
            // try {
            //     const response = await this.$apollo.query({
            //         query: gql`
            //             query bankings(
            //                 $offset: Int
            //                 $limit: Int
            //                 $sortno: String
            //                 $accountno: String
            //                 $accountname: String
            //                 $bankname: String
            //             ) {
            //                 bankings(
            //                 offset: $offset
            //                 limit: $limit
            //                 sortno: $sortno
            //                 accountno: $accountno
            //                 accountname: $accountname
            //                 bankname: $bankname                  
            //             ) {
            //                 id
            //                 sortno
            //                 accountno
            //                 accountname                    
            //                 bankname   
            //                 currency
            //                 balance_at
            //                 balance
            //                 statement_balance
            //                 statement_at              
            //                 unreconciled                  
            //                 isactive   
            //                 isdashboard
            //                 url        
            //                 type
            //                 blac
            //                 updated_by
            //                 updated_at
            //             }
            //             }
            //         `,
            //         variables,
            //     });

            //     if (limit == 0) {
            //         state.selected = response.data.bankings
            //     } else {
            //         state.items = []
            //         state.items = response.data.bankings;
            //     }

            // } catch (error) {
            // }
            state.busy = false;
        },

        async transactions_click(a, ss) {

            let state = this.transactions;

            switch (a) {
                case "selectall":
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    await this.transactions_load(0);
                    break;
                case "add":
                case "edit":
                    // this.component = "BankingsEdit";
                    break;

                case "delete":

                    break;
            }
        },
        async transactions_select(ss, tools) {

            let state = this.transactions;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "export", "add"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "import",];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async transactions_save(ss) {

            let variables = {
                rows: this.cleanit(ss),
            };
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_save(
                            $rows: [BankingLine_input]               
                        ) {
                            bankingslines_save(rows: $rows) {
                            id
                            }
                        }
                        `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.transactions_load(0);

        },
        async save_it() {

            console.log('save_it', this.payindex)

            this.busy = true

            let variables = {}
            let signofvalue = parseFloat(this.value.amount) > 0 ? -1 : 1
            switch (this.payindex) {
                case 0:
                    variables.rows = JSON.parse(JSON.stringify(this.sl_lines.filter(o => o.amount)))

                    // ENSURE CORRECT SIGN FROM STATEMENT LINE IS SENT THROUGH
                    for (var j = 0; j < variables.rows.length; ++j) {
                        variables.rows[j].amount = parseFloat(variables.rows[j].amount * signofvalue).toFixed(2)
                    }
                    variables.rows = variables.rows.map(obj => ({ ...obj, bankinglines_id: this.item.id }))
                    variables.rows = variables.rows.map(obj => ({ ...obj, date_at: this.$moment.unix(this.value.date_at * .001).utc(true).format('YYYY-MM-DD') + " " + this.$moment().format('HH:mm') }))

                    if (this.allocateonly) {
                        variables.allocateonly = this.allocateonly
                        variables.referenceno = this.referenceno
                    }
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation SL_payments_onaccount_save(
                                    $rows: [SL_payments_onaccount_input]    
                                    $referenceno:String
                                    $allocateonly:Boolean      
                                ) {
                                    SL_payments_onaccount_save(rows:$rows,referenceno:$referenceno,allocateonly:$allocateonly) {
                                        id
                                        type
                                        bankinglines_id
                                        link_id
                                        link_type      
                                        who
                                        what
                                        why
                                        vat
                                        ref
                                        transfer
                                        fee
                                        adjust
                                        link
                                        deleted
                                        dicuss
                                        date_at
                                        amount
                                        difference
                                        created_at
                                        updated_at
                                        created_by
                                        updated_by                        
                                    }
                                }
                                `,
                            variables,
                        });

                        let reconciled = response.data.SL_payments_onaccount_save[0]
                        this.message = "<span class='text-primary'>Saved it. " + reconciled.ref + "</span>";

                        this.item.matches = [
                            {
                                id: reconciled.id,
                                type: "matched",
                                bankinglines_id: reconciled.bankinglines_id,
                                link_id: "",
                                link_type: "1",
                                date_at: reconciled.date_at,
                                transfer: "",
                                ref: reconciled.ref,
                                who: reconciled.who,
                                what: reconciled.what,
                                why: reconciled.why,
                                vat: "0",
                                fee: "0",
                                adjust: "0",
                                amount: reconciled.amount,
                                link: reconciled.link,
                                deleted: "0"
                            }
                        ]
                        this.postit_disabled = true

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message.split('GraphQL error: ').join('') + "</span>";
                        this.postit_disabled = false
                    }
                    break;

                case 1:

                    variables.rows = JSON.parse(JSON.stringify(this.bl_lines.filter(o => o.amount)))

                    // ENSURE CORRECT SIGN FROM STATEMENT LINE IS SENT THROUGH
                    for (var j = 0; j < variables.rows.length; ++j) {
                        variables.rows[j].amount = parseFloat(variables.rows[j].amount * signofvalue).toFixed(2)
                    }
                    variables.rows = variables.rows.map(obj => ({ ...obj, bankinglines_id: this.item.id }))
                    variables.rows = variables.rows.map(obj => ({ ...obj, date_at: this.$moment.unix(this.value.date_at * .001).utc(true).format('YYYY-MM-DD') + " " + this.$moment().format('HH:mm') }))

                    if (this.allocateonly) {
                        variables.allocateonly = this.allocateonly
                        variables.referenceno = this.referenceno
                    }
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation BL_payments_onaccount_save(
                                    $rows: [BL_payments_onaccount_input] 
                                    $referenceno:String
                                    $allocateonly:Boolean               
                                ) {
                                    BL_payments_onaccount_save(rows:$rows,referenceno:$referenceno,allocateonly:$allocateonly) {
                                        id
                                        type
                                        bankinglines_id
                                        link_id
                                        link_type      
                                        who
                                        what
                                        why
                                        vat
                                        ref
                                        transfer
                                        fee
                                        adjust
                                        link
                                        deleted
                                        dicuss
                                        date_at
                                        amount
                                        difference
                                        created_at
                                        updated_at
                                        created_by
                                        updated_by                              
                                    }
                                }
                                `,
                            variables,
                        });

                        let reconciled = response.data.BL_payments_onaccount_save[0]
                        this.message = "<span class='text-primary'>Saved it. " + reconciled.ref + "</span>";

                        this.item.matches = [
                            {
                                id: reconciled.id,
                                type: "matched",
                                bankinglines_id: reconciled.bankinglines_id,
                                link_id: "",
                                link_type: "1",
                                date_at: reconciled.date_at,
                                transfer: "",
                                ref: reconciled.ref,
                                who: reconciled.who,
                                what: reconciled.what,
                                why: reconciled.why,
                                vat: "0",
                                fee: "0",
                                adjust: "0",
                                amount: reconciled.amount,
                                link: reconciled.link,
                                deleted: "0"
                            }
                        ]
                        this.postit_disabled = true

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message.split('GraphQL error: ').join('') + "</span>";
                        this.postit_disabled = false
                    }
                    break;

            }

            this.busy = false
        },
        async remove_it() {

            if (await this.$bvModal.msgBoxConfirm('The statement line will need to allocated again. Note: Only unmatched payments can be removed and redone.', {
                title: 'Remove and redo this posting?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                this.busy = true
                let variables = { id: this.value.id };

                switch (this.payindex) {
                    case 0:
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation SL_payments_onaccount_delete(
                                    $id:String
                                ) {
                                    SL_payments_onaccount_delete(id:$id)
                                }
                                `,
                            variables,
                        });



                        break;

                    case 1:
                        break;
                }

                // REFRESH THE GRID
                this.$emit('go')
            }

        },
        async close_it() {
            this.matchesShow = false;
            this.tabindex = 1;
            this.postit_disabled = false
            this.allocateonly = false
            this.slac = null
            this.blac = null
            this.referenceno = null
            this.message = null
            this.$emit('go')

        },
        addLine() {
            let _copy = {}
            switch (this.payindex) {
                case 0:
                    _copy = { ...this.sl_lines[this.sl_lines.length - 1] }
                    _copy.prefix = this.sl_lines[this.sl_lines.length - 1].prefix
                    _copy.description = this.sl_lines[this.sl_lines.length - 1].description
                    _copy.slac = this.sl_lines[this.sl_lines.length - 1].slac
                    _copy.eventcode = this.sl_lines[this.sl_lines.length - 1].eventcode
                    _copy.nlcode = "1100"
                    _copy.amount = this.sl_lines[this.sl_lines.length - 1].amount
                    this.sl_lines.push(_copy)
                    break;
                case 1:
                    _copy = { ...this.bl_lines[this.bl_lines.length - 1] }
                    _copy.prefix = this.bl_lines[this.bl_lines.length - 1].prefix
                    _copy.description = this.bl_lines[this.bl_lines.length - 1].description
                    _copy.blac = this.bl_lines[this.bl_lines.length - 1].blac
                    _copy.eventcode = this.bl_lines[this.bl_lines.length - 1].eventcode
                    _copy.nlcode = "1200"
                    _copy.amount = this.bl_lines[this.bl_lines.length - 1].amount
                    this.bl_lines.push(_copy)
                    break;
            }
            this.edited = true
        },
        delLine(index) {
            switch (this.payindex) {
                case 0:
                    this.sl_lines.splice(index - 1, 1)
                    break;
                case 1:
                    this.bl_lines.splice(index - 1, 1)
                    break;
            }
            this.edited = true
        },
        onClose() {
            this.popoverStatement = false
            this.popoverMatch = false
        },
        onShow() {
            // This is called just before the popover is shown
            // Reset our popover form variables
            // this.input1 = ''
            // this.input2 = ''
            // this.input1state = null
            // this.input2state = null
            // this.input1Return = ''
            // this.input2Return = ''
        },
        onShown() {
            // Called just after the popover has been shown
            // Transfer focus to the first input
            // this.focusRef(this.$refs.input1)
        },
        onHidden() {
            // Called just after the popover has finished hiding
            // Bring focus back to the button
            // this.focusRef(this.$refs.button)
        },
        focusRef(ref) {
            // Some references may be a component, functional component, or plain element
            // This handles that check before focusing, assuming a `focus()` method exists
            // We do this in a double `$nextTick()` to ensure components have
            // updated & popover positioned first
            this.$nextTick(() => {
                this.$nextTick(() => {
                    ; (ref.$el || ref).focus()
                })
            })
        }
    }
};
</script>

<style></style>